export type PetSize = 'PP' | 'P' | 'M' | 'G' | 'GG';

export interface TransferByPetSize {
  pet_size: PetSize;
  value: number;
}

export interface Category {
  id: number;
  name: string;
  price?: string;
  description?: string;
  transfers: TransferByPetSize[];
}

export interface ViaCepResponse {
  cep: string;
  logradouro: string;
  bairro: string;
  localidade: string;
  uf: string;
  erro?: boolean;
}

interface CreateAddressDto {
  zip_code: string;
  street: string;
  number: string;
  complement?: string;
  neighborhood: string;
  city: string;
  state: string;
}

interface CreateUserDto {
  full_name: string;
  email: string;
  document: string;
  password: string;
  phone: string;
}

interface CreatePetshopDto {
  pet_shop_name: string;
  company_name: string;
  cnpj: string;
  phone: string;
  email: string;
  category_id: number | null;
  address: CreateAddressDto;
}

export interface PetshopUserPayload {
  user: CreateUserDto;
  petshop: CreatePetshopDto;
}

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

export const api = {
  getPublicCategories: async (): Promise<Category[]> => {
    const response = await fetch(`${API_URL}/plan-categories/public`);
    if (!response.ok) {
      throw new Error('Erro ao buscar categorias');
    }
    return response.json();
  },

  createPetshopUser: async (data: PetshopUserPayload): Promise<void> => {
    const response = await fetch(`${API_URL}/petshops/user`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Erro ao cadastrar usuário e petshop');
    }

    return response.json();
  },
};
